import {
  editAccountApi,
  getWithdrawTypeAndSubApi,
} from '@/api/assets'
import { showToast } from '@/utils'
import router from '@/router'
import { TabInfo, SelectInfo } from '../../type'
import { useElementBounding } from '@vueuse/core'
import { v4 as uuidv4 } from 'uuid';
import useWidthdrawData from '../../hooks/useWidthdrawData'
import useSpecialChar from '../../hooks/useSpecialChar'
export default () => {
  const withdrawStore = useWithdrawStore() // 提现信息 phoneCode
  const userStore = useUserStore() // 用户信息
  const tenantStore = useTenantStore() // 商户信息
  const { t } = useI18n() // 国际化
  const footEl = ref(null)
  const { height }
    = useElementBounding(footEl)
  const distance = computed(() => `${((height.value) * 3) / 16}rem`)
  const { phoneCode } = toRefs(tenantStore)
  const { tabId: activeId } = toRefs(withdrawStore)
  const { withdrawType } = toRefs(userStore)
  const loading = ref(false)
  const tabId = ref(activeId.value)
  const tabList = ref<TabInfo[]>([])
  const typeList = ref<SelectInfo[]>([])
  const list = ['realName', 'PHONE', 'IFSC', 'code', 'EMAIL', "BANKACCOUNT"]
  const accountInfo = reactive<Record<string, any>>({})
  const formEl = ref(null)
  const tabName = ref('')
  const withdrawTypeSubMap = new Map() // 提现类型子类Map
  const withdrawIdNameMap = new Map() // 提现类型子类Map
  const elObj: Record<string, any> = {}
  list.forEach((it) => {
    accountInfo[it] = ''
    elObj[`${it}El`] = ref(null)
  })


  const btnDisabled = computed(() => {
    let { realName, PHONE, IFSC, code, BANKACCOUNT } = accountInfo
    const IFSCBool = phoneCode.value === '+63' ? true : !!IFSC
    return !!realName && !!PHONE && IFSCBool && !!code && BANKACCOUNT

  })


  const init = (tabId: number) => {
    typeList.value = withdrawTypeSubMap.get(tabId)
    tabName.value = withdrawIdNameMap.get(tabId)
  }
  onMounted(async () => {

    let {
      activeTabId,
      mainTabList
    } = await useWidthdrawData((it: any) => {
      withdrawTypeSubMap.set(it.id, it.tenantPayWithdrawTypeSub)
      withdrawIdNameMap.set(it.id, it.name)

    })
    tabId.value = activeTabId
    tabList.value = mainTabList
    init(tabId.value)
  })

  const tabChange = (activeId: number) => {
    withdrawStore.tabId = activeId
    init(activeId)
  }

  const addAccount = async () => {

    let nodeList = formEl.value?.querySelectorAll(".ion-invalid")
    if (nodeList && nodeList.length) return
    let withdrawInfo = []
    let code = accountInfo.code
    let relatedCode = uuidv4()
    //  真实姓名只保留128个字符
    if (accountInfo.realName.length > 128) {
      accountInfo.realName = accountInfo.realName.slice(0, 128)
    }
    for (let key in accountInfo) {
      if (key !== 'code' && accountInfo[key]) {
        withdrawInfo.push({
          code,
          valueType: key.toUpperCase(),
          value: accountInfo[key],
          isDefault: true,
          relatedCode
        })
      }

    }
    let accounts = [
      {
        tenantWithdrawTypeId: tabId.value,
        withdrawInfo
      }

    ]

    try {
      await editAccountApi({ accounts, operationType: "add" })
      showToast(`${t(`toast.bindSuccess`)}`)
      router.back()
    } catch (error) {
      // showToast(`${t(`toast.bindFail`)}`)
    }

  }
  const selectChange = (e: CustomEvent) => {
    accountInfo.code = e.detail.value

  }
  const handleInput = (event: CustomEvent) => {
    setTimeout(() => {
      accountInfo.realName = useSpecialChar(event)
      // if (elObj.realNameEl.value) {
      //   elObj.realNameEl.value.$el.value = event.target!.value.replace(/[^a-zA-Z0-9]+/g, '');
      // }
    })

  }

  return {
    loading,
    tabId,
    typeList,
    withdrawType,
    accountInfo,
    btnDisabled,
    tabList,
    elObj,
    formEl,
    tabName,
    distance,
    footEl,
    phoneCode,
    t,
    addAccount,
    selectChange,
    tabChange,
    handleInput,

  }
}
